import { transport } from 'config/transport';

export function callApiUpdateAcademicYears(body) {
    return transport.put(`/mamnon/academicYears`, body);
}
